import { useTranslation } from 'react-i18next'
import { IProduct } from '../../types/products'
import { minimumQuantity } from '../../utils/minimumQuantity'
import './MinimumQuantity.scss'

export default function MinimumQuantity({ product, invalid = false, compact = false }: {
  product?: IProduct
  invalid?: boolean
  compact?: boolean
}) {
  const { t } = useTranslation()
  const minimum = minimumQuantity(product)
  if (minimum <= 1 && !invalid) return null
  if (compact && !invalid) {
    return (
      <span className='minimum-quantity-badge' title={t('PRODUCT_MINIMUM', { minimum })}>
        {t('PRODUCT_MINIMUM_SHORT', { minimum })}
      </span>
    )
  }
  return (
    <div className={`minimum-quantity${invalid ? ' minimum-quantity--error' : ''}${compact ? ' minimum-quantity--compact' : ''}`} role={invalid ? 'alert' : undefined}>
      {t(invalid ? (compact ? 'PRODUCT_MINIMUM_ERROR_SHORT' : 'PRODUCT_MINIMUM_ERROR') : 'PRODUCT_MINIMUM', {
        minimum,
        remaining: Math.max(0, minimum - Number(product?.quantity ?? 0)),
      })}
    </div>
  )
}
